import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, connectAuthEmulator } from 'firebase/auth'

// Firebase web config is public (embedded in the client JS bundle).
// Security is enforced by Firestore rules and Firebase Auth, not by hiding these values.
const firebaseConfig = {
  apiKey: 'AIzaSyARw_o_WB8ZSaCEYED-OA-4n6sX0UDId4c',
  authDomain: 'day-one-workshop.firebaseapp.com',
  projectId: 'day-one-workshop',
  storageBucket: 'day-one-workshop.firebasestorage.app',
  messagingSenderId: '365971905055',
  appId: '1:365971905055:web:e9deaf7fb750f71e34532a',
}

export const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = getAuth(app)

// The local end-to-end harness (scripts/e2e-local.sh) points the SDK at the Firebase
// emulators instead of production. This can never be true in a deployed build: VITE_
// vars are inlined at build time and only the harness sets this one. Module bodies
// evaluate once, so each connect* call happens exactly once.
if (import.meta.env.VITE_USE_EMULATORS === '1') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
}
